export default "__VITE_ASSET__DmGVGg7o__"